// Shared by sale cards and optional legacy purchase controls.
(() => {
  if (window.DreameQuickCheckoutInitialized) return;
  window.DreameQuickCheckoutInitialized = true;

  let checkoutPending = false;
  const checkoutErrors = new WeakMap();

  async function checkoutURL(variantId, source) {
    if (
      checkoutPending ||
      source.disabled ||
      source.getAttribute('aria-disabled') === 'true'
    )
      return;
    const id = Number(variantId);
    const wasDisabled = source.disabled;
    const previousBusy = source.getAttribute('aria-busy');
    const previousDisabled = source.getAttribute('aria-disabled');
    let cartChanged = false;
    let checkoutRedirected = false;
    checkoutPending = true;
    if ('disabled' in source) source.disabled = true;
    source.setAttribute('aria-busy', 'true');
    source.setAttribute('aria-disabled', 'true');
    const previousError = checkoutErrors.get(source);
    if (previousError) previousError.textContent = '';

    function restoreSource() {
      checkoutPending = false;
      if ('disabled' in source) source.disabled = wasDisabled;
      if (previousBusy === null) source.removeAttribute('aria-busy');
      else source.setAttribute('aria-busy', previousBusy);
      if (previousDisabled === null) source.removeAttribute('aria-disabled');
      else source.setAttribute('aria-disabled', previousDisabled);
    }

    try {
      // Validate before clearing: malformed IDs must not empty the customer's cart.
      if (!Number.isSafeInteger(id) || id <= 0)
        throw new Error(
          'Unable to select this product. Please refresh and try again.',
        );
      if (!window.CartApi)
        throw new Error(
          'Unable to start checkout. Please refresh and try again.',
        );
      // Preserve clear -> add one item -> gifts -> checkout. Reconcile gifts only
      // after both writes, not against the temporarily empty cart.
      cartChanged = true;
      await window.CartApi.clear({ skipAfterMutation: true });
      await window.CartApi.add([{ id: id, quantity: 1 }], {
        skipAfterMutation: true,
      });
      try {
        await window.CartGiftManager?.run();
      } catch (error) {
        console.error('立即购买赠品同步失败:', error);
      }
      window.location.href = window.CartApi.root + 'checkout';
      checkoutRedirected = true;
    } catch (err) {
      const message = window.CartApi
        ? window.CartApi.getErrorMessage(
            err,
            'Unable to start checkout. Please try again.',
          )
        : err.message;
      let errorRegion = checkoutErrors.get(source);
      if (!errorRegion) {
        errorRegion = document.createElement('div');
        errorRegion.setAttribute('role', 'alert');
        source.insertAdjacentElement('afterend', errorRegion);
        checkoutErrors.set(source, errorRegion);
      }
      errorRegion.textContent = message;
      // A failed response may still have committed a write; recover real state.
      if (cartChanged) {
        try {
          const cart = await window.CartApi.get();
          document.dispatchEvent(
            new CustomEvent('cart:updated', { detail: cart }),
          );
        } catch (readError) {
          console.error('立即购买购物车状态读取失败:', readError);
        }
      }
    } finally {
      // Keep the lock while the checkout navigation is pending.
      if (!checkoutRedirected) {
        restoreSource();
      } else {
        // A Back navigation may restore this document from the browser cache.
        window.addEventListener(
          'pageshow',
          function (event) {
            if (event.persisted) restoreSource();
          },
          { once: true },
        );
      }
    }
  }

  $(document).on('click', '.checkout-or-cart .add-to-cart-btn', function () {
    $(this)
      .parents('.checkout-or-cart')
      .siblings()
      .find('button.btn--add-to-cart')
      .trigger('click');
    return false;
  });
  $(document).on(
    'click',
    '.showcase-buy-now[data-id], .another-btn[data-id]',
    function (event) {
      event.preventDefault();
      if ($(this).closest('.product-link-box').hasClass('has-sold-out')) return;
      if ($(this).siblings().find('button.btn--add-to-cart').prop('disabled'))
        return;
      // One owner for checkout: never trigger a hidden purchase control as well.
      checkoutURL($(this).attr('data-id'), this);
    },
  );
})();
